import React from 'react';
import { split, last, get, find, isEmpty, orderBy, uniqBy } from 'lodash';
import { Box } from '@material-ui/core';
import * as Scroll from 'react-scroll';

import { InlineCaption } from 'components/NotificationsBloc/styles';
import PAGES from 'routes/pages';
import { AssuranceIcon } from 'images';
import { CGS_EPARGN, EXCLUDED_TYPES } from 'utils/globalConst';
import { getApiBaseUrl } from 'helpers/api';
import { Tab } from 'store/user/types';
import moment from 'moment';

const baseUrl = getApiBaseUrl();

export const capitalize = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

export const uppercase = (s: string) => s.toUpperCase();

export const getTextBetweenQuotation = (message: string) => {
  return message.split(' ').map((item: string, index: number) => {
    if (/"\w+\W*/i.test(item)) {
      const array = item.split('"');
      return (
        <Box component="span" key={index}>
          {array[0]}
          <InlineCaption color="white" weight="bold">
            {array[1]}
          </InlineCaption>
          {array[2] && array[2]}{' '}
        </Box>
      );
    } else if (/\w+\W*"/i.test(item)) {
      const array = item.split('"');
      return (
        <Box component="span" key={index}>
          <InlineCaption color="white" weight="bold">
            {array}
          </InlineCaption>{' '}
        </Box>
      );
    }
    return item + ' ';
  });
};

export const getVideoIdFormUrl = (url: string) => {
  const splitBySlash = split(url, '/');
  const result = split(last(splitBySlash), '?');
  return result[0];
};

export const renderPath = (type: string) => {
  switch (type) {
    case 'AUTO':
      return PAGES.AUTODASHBOARD;
    case 'MRH':
      return PAGES.MRHDASHBOARD;
    case 'EPARGN':
      return PAGES.EPARGN_DASHBOARD;
    case 'AMC':
      return PAGES.AMC_DASHBOARD;
    //TODO: add a default route or throw an error
  }
};
export const renderPosition = (type: string) => {
  switch (type) {
    case 'AUTO':
      return 0;
    case 'MRH':
      return 1;
    case 'EPARGN':
      return 2;
    case 'AMC':
      return 3;
  }
};

export const exactType = (type: string) => {
  switch (type) {
    case 'auto-contrat-details':
      return 'AUTO';
    case 'habitation-contrat-details':
      return 'MRH';
    case 'epargne-contrat-details':
      return 'EPARGN';
    case 'habitation':
      return 'MRH';
    case 'epargne':
      return 'EPARGN';
    case 'sante':
    case 'sante-contrat-details':
      return 'AMC';
    default:
      return 'AUTO';
  }
};
export const currencyFormat = (num: number) => {
  if (!num || num === 0 || num === -2 || num === -1) {
    return '-';
  } else {
    return (
      num &&
      num
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        .split(',')
        .join(' ')
    );
  }
};
export const renderUnit = (value: number, isAr: boolean) => {
  if (value === 0 || value === -2 || value === -1) {
    return '';
  } else if (isAr) {
    return ' د.م';
  }
  return ' DH';
};
export const renderUnitTaux = (value: number) => {
  if (value === 0 || value === -2 || value === -1) {
    return '';
  } else return '%';
};

export const correctDateForm = (date: string) =>
  date.split('/').reverse().join('-');

export const renderTitleFaq = (code: string) => {
  switch (code) {
    case 'auto':
      return 'AssuranceAuto';
    case 'habitation':
      return 'AssuranceMrh';
    case 'sinistreAuto':
      return 'SinistreAuto';
    case 'epargn':
      return 'AssuranceEpargn';
    case 'sante':
      return 'AssuranceAmc';
    default:
      return code;
  }
};
export const renderTagsFaq = (code: string) => {
  switch (code) {
    case 'auto':
      return 'autoKeyword';
    case 'habitation':
      return 'MrhKeyWord';
    case 'sinistreAuto':
      return 'SinistreKeyword';
    case 'epargn':
      return 'epargnKeyword';
    case 'sante':
      return 'amcKeyword';
    default:
      return code;
  }
};
export const renderBgFaq = (code: string) => {
  switch (code) {
    case 'auto':
      return get(AssuranceIcon, 'autoBgFaq');
    case 'habitation':
      return get(AssuranceIcon, 'mrhBgFaq');
    case 'sinistreAuto':
      return get(AssuranceIcon, 'autoBgFaq');
    case 'epargn':
      return get(AssuranceIcon, 'epargnBgFaq');
    case 'sante':
      return get(AssuranceIcon, 'amcBgFaq');
    default:
      return code;
  }
};
export const renderIconFaq = (code: string) => {
  switch (code) {
    case 'auto':
      return get(AssuranceIcon, 'AutoMainIcon');
    case 'habitation':
      return get(AssuranceIcon, 'mrhIconFaq');
    case 'sinistreAuto':
      return get(AssuranceIcon, 'sinsitreIconFaq');
    case 'epargn':
      return get(AssuranceIcon, 'iconFaqEpargn');
    case 'sante':
      return get(AssuranceIcon, 'amcIconFaq');
    default:
      return code;
  }
};
export const renderLinkFile = (type: number) => {
  switch (type) {
    case 250:
      return CGS_EPARGN.AlMoustakbalChaabi;
    case 249:
      return CGS_EPARGN.AssurRetrait;
    case 197:
      return CGS_EPARGN.AddamaneChaabi;
    default:
      return '';
  }
};
export function getAttestationEpargn(
  codeProduit: string,
  numPolice: string,
  numAdhesion: string,
  matricule: string,
  ppr: string,
  token: any,
) {
  return `${baseUrl}/user/get-attestion-epargn?codeProduit=${codeProduit}&numPolice=${numPolice}&numAdhesion=${numAdhesion}&matricule=${matricule}&ppr=${ppr}&token=${token}`;
}

export function formatEpargnProducts(
  products: {
    LIBELLE_PRODUIT: string;
    CODE_PRODUIT: number;
    NUM_POLICE: string;
    MATRICULE: string;
    NUM_ADHESION: string;
    PPR: string;
  }[],
) {
  return products.map((product) => ({
    label: capitalize(product.LIBELLE_PRODUIT),
    value: product.CODE_PRODUIT.toString(),
    policyNumber: product.NUM_POLICE,
    matricule: product.MATRICULE,
    numAdhesion: product.NUM_ADHESION,
    ppr: product.PPR,
  }));
}

export const isFieldRequired = (
  products: any,
  productValue: string,
  field: string,
): boolean => {
  if (products?.length === 0 || !productValue) return false;
  const product = find(products, (item) => item.value === productValue);
  const REQUIRED_MESSAGE = 'INPUT OBLIGATOIR';
  if (!product) return false;
  return product[field] === REQUIRED_MESSAGE;
};

export const checkField = (
  code: string,
  products: {
    label: string;
    value: string;
    policyNumber: string;
    matricule: string;
    numAdhesion: string;
    ppr: string;
  }[],
) => {
  const isMatricule: boolean = false;
  const isPpr: boolean = false;
  const isAdhesion: boolean = false;
  if (
    !isEmpty(find(products, { value: code })) &&
    find(products, { value: code })?.matricule === 'INPUT OBLIGATOIR'
  ) {
    return {
      isMatricule: !isMatricule,
      isPpr: isPpr,
      isAdhesion: isAdhesion,
    };
  } else if (
    !isEmpty(find(products, { value: code })) &&
    find(products, { value: code })?.numAdhesion === 'INPUT OBLIGATOIR'
  ) {
    return {
      isMatricule: isMatricule,
      isPpr: isPpr,
      isAdhesion: !isAdhesion,
    };
  } else if (
    !isEmpty(find(products, { value: code })) &&
    find(products, { value: code })?.ppr === 'INPUT OBLIGATOIR'
  ) {
    return {
      isMatricule: isMatricule,
      isPpr: !isPpr,
      isAdhesion: isAdhesion,
    };
  }
};
export const scrollFunction = (type: string) => {
  switch (type) {
    case 'epargn':
      return Scroll.animateScroll.scrollTo(600);
    case 'habitation':
      return Scroll.animateScroll.scrollTo(450);
    case 'auto':
      return Scroll.animateScroll.scrollTo(350);
    default:
      return Scroll.animateScroll.scrollTo(0);
  }
};

export const tabsFromResponse = (roles: any) => {
  let tabs = roles
    .map((item: Tab) => ({
      position: renderPosition(item.type),
      path: renderPath(item.type),
      type: item.type,
    }))
    .filter((item: Tab) => !EXCLUDED_TYPES.includes(item.type));
  tabs = orderBy(
    uniqBy(tabs, (item: any) => item.type),
    (item: any) => item.position,
  );
  return tabs;
};
export function reversedNum(num: any) {
  return num.toString().split(' ').reverse().join(' ');
}
export const dateFindAn = (date: string) => {
  return (
    '31/' +
    '12/' +
    (Number(moment(date, 'YYYY-MM-DD').format('YYYY')) - 1).toString()
  );
};

export const _renderTypePrime = (typePrime: string, useIntl: Function) => {
  const { formatMessage } = useIntl();
  switch (typePrime) {
    case 'VP':
      return formatMessage({ id: 'epargn.contribution.prime_type.periodic' });
    case 'VL':
      return formatMessage({
        id: 'epargn.contribution.prime_type.exceptional',
      });
    default:
      return typePrime;
  }
};
